var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
var IOCheckMarkSVG = function (props) {
    return (React.createElement("svg", __assign({ width: "20", height: "20", viewBox: "0 0 20 20", fill: "var(--turquoise-dark)", clipRule: "evenodd", fillRule: "evenodd", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M18.4184 5.617L6.86857 16.1358L1.57251 11.164L2.71325 9.94887L6.88573 12.1992L17.2961 4.38477L18.4184 5.617Z" })));
};
export default IOCheckMarkSVG;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSU9DaGVja01hcmsuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJJT0NoZWNrTWFyay50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7QUFBQSxPQUFPLEtBQUssTUFBTSxPQUFPLENBQUM7QUFJMUIsSUFBTSxjQUFjLEdBQWtDLFVBQUMsS0FBSztJQUMxRCxPQUFPLENBQ0wsc0NBQ0UsS0FBSyxFQUFDLElBQUksRUFDVixNQUFNLEVBQUMsSUFBSSxFQUNYLE9BQU8sRUFBQyxXQUFXLEVBQ25CLElBQUksRUFBQyx1QkFBdUIsRUFDNUIsUUFBUSxFQUFDLFNBQVMsRUFDbEIsUUFBUSxFQUFDLFNBQVMsRUFDbEIsS0FBSyxFQUFDLDRCQUE0QixJQUM5QixLQUFLO1FBRVQsOEJBQU0sQ0FBQyxFQUFDLDhHQUE4RyxHQUFHLENBQ3JILENBQ1AsQ0FBQztBQUNKLENBQUMsQ0FBQztBQUVGLGVBQWUsY0FBYyxDQUFDIn0=